import { HYDRATE_STATE } from '../../store/consts';
import type { Project, Status, Cards, Connections, OnPremiseKeys } from '../../types/Wizard';
export interface State {
    token: string | null;
    status: Status;
    project: Project;
    projects: Project[];
    connections: Connections;
    cards: Cards | null;
    initialCards: null;
    onPremiseKeys: OnPremiseKeys | null;
}

const getDefaultState = (): State => ({
    token: null,
    status: {
        deployed: false,
        error: null,
        valid: null,
        validations: {},
        requirements: {},
        connectGithubAndCreateSite: null,
        digitaloceanIsChecked: false,
        isSubmitting: null,
        registerOverlay: null,
        ssgCardEnabled: false,
        cmsCardEnabled: false,
        repositoryCardEnabled: false,
        deploymentCardEnabled: false,
        fetchingProjectByCoreId: false
    },
    project: {
        id: null,
        name: null,
        organizationId: null,
        wizard: {}
    },
    projects: [],
    connections: {
        theme: {},
        ssg: {},
        cms: {},
        repository: {},
        container: {},
        deployment: {}
    },
    cards: null,
    initialCards: null,
    onPremiseKeys: null
});

const wizard = (state = getDefaultState(), action: $TSFixMe): State => {
    switch (action.type) {
        case HYDRATE_STATE: {
            return {
                ...getDefaultState(),
                ...action.data.wizard
            };
        }
        case 'RESET_WIZARD': {
            return {
                ...getDefaultState()
            };
        }
        case 'SOFT_RESET_WIZARD': {
            return {
                ...state,
                token: getDefaultState().token,
                status: {
                    ...getDefaultState().status
                },
                project: {
                    ...getDefaultState().project
                },
                connections: {
                    ...getDefaultState().connections
                }
            };
        }
        case 'CREATE_PROJECT': {
            return {
                ...state,
                token: action.data.token,
                project: action.data.project
            };
        }
        case 'RESET_PROJECT': {
            return {
                ...state,
                project: {
                    ...getDefaultState().project
                }
            };
        }
        case 'CREATE_PROJECT_FAILED': {
            return {
                ...state,
                token: getDefaultState().token,
                status: {
                    ...getDefaultState().status,
                    error: 'createProjectFailed'
                },
                project: {
                    ...getDefaultState().project
                },
                connections: {
                    ...getDefaultState().connections
                }
            };
        }
        case 'CREATE_CARDS_SUCCEED': {
            return {
                ...state,
                cards: action.data.cards,
                initialCards: action.data.initialCards
            };
        }
        case 'UPDATE_CARDS': {
            return {
                ...state,
                cards: action.data.cards
            };
        }
        case 'UPDATE_PROJECT_CARD': {
            return {
                ...state,
                project: action.data.project
            };
        }
        case 'SET_CONNECTION': {
            return {
                ...state,
                connections: {
                    ...state.connections,
                    ...action.data.connection
                }
            };
        }
        case 'VALIDATE_WIZARD': {
            return {
                ...state,
                status: {
                    ...state.status,
                    ...action.data.status
                }
            };
        }
        case 'DEPLOY_PROJECT_STARTED': {
            return {
                ...state,
                status: {
                    ...state.status,
                    ...action.data.status
                }
            };
        }
        case 'DEPLOY_PROJECT_SUCCEED': {
            return {
                ...state,
                project: action.data.project,
                status: {
                    ...state.status,
                    ...action.data.status
                }
            };
        }
        case 'GET_PROJECTS_BY_CORE_ID_STARTED': {
            return {
                ...state,
                status: {
                    ...state.status,
                    fetchingProjectByCoreId: true
                }
            };
        }
        case 'GET_PROJECTS_BY_CORE_ID_SUCCEED': {
            return {
                ...state,
                projects: action.data.projects,
                status: {
                    ...state.status,
                    ...action.data.status,
                    error: null,
                    fetchingProjectByCoreId: false
                }
            };
        }
        case 'GET_PROJECTS_BY_CORE_ID_FAILED': {
            return {
                ...state,
                project: action.data.project,
                status: {
                    ...state.status,
                    ...action.data.status,
                    fetchingProjectByCoreId: false
                }
            };
        }
        case 'DEPLOY_PROJECT_FAILURE': {
            return {
                ...state,
                token: action.data.token,
                status: {
                    ...state.status,
                    ...action.data.status
                }
            };
        }
        case 'UPDATE_WIZARD_STATUS': {
            return {
                ...state,
                status: {
                    ...state.status,
                    ...action.data.status
                }
            };
        }
        case 'UPDATE_REQUIREMENTS': {
            return {
                ...state,
                status: {
                    ...state.status,
                    requirements: {
                        ...action.data.requirements
                    }
                }
            };
        }
        case 'UPDATE_HEALTHCHECK': {
            return {
                ...state,
                status: {
                    ...state.status,
                    ...action.data.status
                }
            };
        }
        case 'UPDATE_PROJECT_NAME': {
            return {
                ...state,
                project: {
                    ...state.project,
                    name: action.data.name
                }
            };
        }
        case 'UPDATE_PROJECT_ORG_ID': {
            return {
                ...state,
                project: {
                    ...state.project,
                    organizationId: action.data.organizationId
                }
            };
        }
        case 'POLL_PROJECT': {
            return {
                ...state,
                project: action.data.project
            };
        }
        case 'TRIGGER_DEPLOY': {
            return {
                ...state,
                status: {
                    ...state.status,
                    isSubmitting: true
                }
            };
        }
        case 'TRIGGER_DEPLOY_ERROR': {
            return {
                ...state,
                status: {
                    ...state.status,
                    isSubmitting: false
                }
            };
        }
        case 'ON_PREMISE_KEYS_FETCHED': {
            return {
                ...state,
                onPremiseKeys: action.data.onPremiseKeys
            };
        }
        default: {
            return state;
        }
    }
};

export default wizard;

export const localStorePaths = ['token', 'status', 'project', 'connections', 'cards', 'initialCards'];
